import FluxPromptSampleAccessGate from './components/FluxPromptSampleAccessGate';
import FluxPromptSamplePage from './pages/FluxPromptSamplePage';

export default function FluxPromptSampleApp() {
  return (
    <FluxPromptSampleAccessGate>
      <FluxPromptSamplePage />
    </FluxPromptSampleAccessGate>
  );
}
